module.exports = __webpack_public_path__ + "img/icon_20.c9631679.png";